// removed by extract-text-webpack-plugin
module.exports = {"listArticle":"_2DD3uMRRigwSH2Vnd46QK_","listStock":"_2P2GOy2QWPMdDBO4E66vAC","container":"rtsl1t68F1lblvej8SAGA","row":"_17wegkj7ZS5A6lsOJs9RQN","left":"_gPoiwBIjDrHnYv9Qdqh-","right":"_3qQSXAPXLl-XlFXWheaKJ3","priceField":"_1zC5D4kwVZIhbTEDsdHwaa"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/Article/style.scss
// module id = 952
// module chunks = 0